
import React, { useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { usePublicSettings } from '@/hooks/usePublicSettings';

const WelcomeMessage = () => {
  const { t, language } = useLanguage();
  const { config } = usePublicSettings();
  
  // Use custom message if available, otherwise fall back to translation
  const welcomeText = config.use_custom_welcome_message && config.welcome_message_custom[language] 
    ? config.welcome_message_custom[language]
    : t('welcome_message');
  
  return (
    <section className="mb-6 relative z-10">
      <div className="p-6 bg-white/80 backdrop-blur-sm rounded-xl border border-museum-light">
        <div className="text-lg text-gray-700 space-y-4">
          {welcomeText.split('\n\n').map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WelcomeMessage;
